import React from 'react';
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Location } from 'history';
import { connect } from "react-redux";
import { Route, Route as RouteType } from '../Types/Route';
import cNames from '../Utility/utility';
import config from '../Config/config';
import styles from '../Assets/Styles/Components/Sidebar.module.css';

type Props = {
	routes: RouteType[],
	collapsed: boolean,
	location: Location,
	profile: any,
};

class Sidebar extends React.Component<Props> {
	sidebarMenuLinks = () => {
		const { routes, location } = this.props;
		return links.map((r) => {
			return (
				<li className={cNames(styles.listItem)} key={r.title}>
					<a className={styles.linkItemLink} href={r.url}>
						<i className={cNames(r.icon || '', styles.linkItemLinkIcon)} />
						<span className={styles.linkItemLinkTitle}>{r.title}</span>
					</a>
				</li>
			);
		});
	}

	render() {
		const { collapsed } = this.props;
		const { kadroUrl, logo, topbarTitle } = config;
		return (
			<aside className={cNames(styles.sidebar, collapsed ? styles.collapse : '')}>
				<a href={kadroUrl} className={styles.logoContainer}>
					<img className={styles.logo} src={logo} alt="logo" />
					<h2 className={styles.title}> {topbarTitle} </h2>
				</a>
				<section className={styles.sidebarMenu}>
					<ul className={styles.sidebarLinks}>
						<li className={cNames(styles.listItem, styles.active)} key="آعکاس">
							<a className={styles.linkItemLink} href="/book">
								<i className={`${styles.linkItemLinkIcon} fas fa-plus`} />
								<span className={styles.linkItemLinkTitle}>رزرو عکاس</span>
							</a>
						</li>
						<li className={cNames(styles.listItem)} key="آتلیه">
							<a className={styles.linkItemLink} href="/pro">
								<i className={`${styles.linkItemLinkIcon} fas fa-plus`} />
								<span className={styles.linkItemLinkTitle}>رزرو آتلیه</span>
							</a>
						</li>
						<li className={cNames(styles.listItem)} key="آدوستان">
							<a className={styles.linkItemLink} href="/app/users/refer_dashboard">
								<i className={`${styles.linkItemLinkIcon} fas fa-heart`} />
								<span className={styles.linkItemLinkTitle}>معرفی به دوستان</span>
							</a>
						</li>
					</ul>
					<div className={styles.smallProfile}>
						<div className={styles.profileAvatar}>
							<i className="fal fa-user-circle" />
						</div>
						<div className={styles.profileDetails}>
							<div className={styles.profileName}>{this.props.profile?.profile && Object.keys(this.props.profile.profile).length !== 0 && this.props.profile.profile.display_name}</div>
							<div className={styles.profileCredit}>اعتبار شما : {this.props.profile?.profile && Object.keys(this.props.profile.profile).length !== 0 && new Intl.NumberFormat().format(this.props.profile.profile.balance)} تومان</div>
						</div>
					</div>
					<ul className={styles.sidebarLinks}>
						{this.sidebarMenuLinks()}
					</ul>
				</section>
			</aside>
		);
	}
}

const mapStateToProps = (state: { profile: any; }) => {
	return {
		profile: state.profile,
	};
};
export default connect(mapStateToProps)(Sidebar);

const links = [
	{
		title: "کیف پول",
		icon: "fas fa-wallet",
		url: "https://www.kadro.co/app/galleries/credit_cash_in"
	},
	{
		title: "چت ها",
		icon: "fas fa-comment",
		url: "https://www.kadro.co/app/rooms"
	},
	{
		title: "سفارش های من",
		icon: "fas fa-th-large",
		url: "https://www.kadro.co/app/galleries"
	},
	{
		title: "تخفیف های من",
		icon: "fas fa-ticket",
		url: "https://www.kadro.co/app/galleries/my_coupons"
	},
	{
		title: "چاپ و رتوش",
		icon: "fas fa-shopping-cart",
		url: "https://www.kadro.co/app/galleries/my_invoices_dashboard"
	}
];
